export default "__VITE_ASSET__DfB8$aP$__"